import preference from './preference';

export default {
    namespaced: true,

    state: {
        authUserEmail: null,
    },

    getters: {
        isLoggedIn(state) {
            return state.authUserEmail !== null || preference.state.magentoLoggedIn;
        }
    },

    mutations: {
        setAuthUserEmail(state, email) {
            state.authUserEmail = email;
        }
    },

    actions: {
        getLoginCredentials({ commit }) {
            const userMetaTag = document.querySelector('meta[name="user"]');

            if (userMetaTag && userMetaTag.getAttribute('content') !== '') {
                commit('setAuthUserEmail', userMetaTag.getAttribute('content'));
            } else {
                commit('setAuthUserEmail', null);
            }
        },
        redirectToLoginUrl() {
            switch (preference.state.mode) {
                case 'magento':
                    window.location.href = '/customer/account/login';
                    break;
                default:
                    window.location.href = '/website/index.php?Show=WebShopUserLogin';
            }
        }
    }
};
